import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LeadResellerVfComponent } from './pages/lead-reseller-vf/lead-reseller-vf.component';
import { PanelAdminComponent } from './pages/panel-admin/panel-admin.component';
import { LoginComponent } from './pages/login/login.component';
import { ResgistroAdminComponent } from './pages/resgistro-admin/resgistro-admin.component';
import { RestaurarPasswordComponent } from './pages/restaurar-password/restaurar-password.component';
import { GestionComponent } from './pages/gestion/gestion.component';
// import { RedirectGuardComponent } from './guards/redirect.guard';

const routes: Routes = [
  { path: 'nuevoRegistroAdmin/:opcion', component: ResgistroAdminComponent},
  // { path: 'restaurarPassword', component: RestaurarPasswordComponent},
  { path: 'login', component: LoginComponent},
  { path: 'panelAdministrador', component: PanelAdminComponent},
  { path: 'gestion/:opcion', component: GestionComponent},
  { path: ':distribuidor', component: LeadResellerVfComponent},
  { path: '', component: LeadResellerVfComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }